(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Set();
  const selector = '.sm-signature__title,.sm-signature__copy,.sm-category,.sm-story__content,.sm-editorial-note h2,.sm-page-heading,.sm-collection-cover__row,.sm-footer-signature';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (reduced.matches || !entry.target.animate) return;
      const animation = entry.target.animate([{opacity:.35,transform:'translateY(24px)'},{opacity:1,transform:'translateY(0)'}],{duration:780,easing:'cubic-bezier(.22,1,.36,1)'});
      active.add(animation);
      animation.finished.then(()=>active.delete(animation)).catch(()=>active.delete(animation));
    });
  },{threshold:.08}) : null;
  const init = root => {
    root.querySelectorAll(selector).forEach(el => {
      if(seen.has(el))return;
      seen.add(el);
      if(observer)observer.observe(el);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  reduced.addEventListener('change',()=>{if(reduced.matches){active.forEach(animation=>animation.cancel());active.clear();}});
  const line = document.querySelector('.sm-reading-line');
  let scheduled = false;
  const progress = () => {
    const max = document.documentElement.scrollHeight-innerHeight;
    if(line)line.style.transform='scaleX('+Math.max(0,Math.min(1,max>0?scrollY/max:0))+')';
    scheduled=false;
  };
  addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(progress);}},{passive:true});
  addEventListener('resize',progress,{passive:true});
  progress();
})();